enum CommonDateFormat {
  DDMMYYYY = "DD/MM/YYYY",
  MMMMDYYYY1 = "MMMM D, YYYY",
  MMMMDYYYY2 = "MMMM D - YYYY",
  MMDDYYYY = "MM/DD/YYYY",
}

export default CommonDateFormat;
